import { render } from "./Widget.vue?vue&type=template&id=09be14ac&lang=html"
import script from "./Widget.vue?vue&type=script&setup=true&lang=js"
export * from "./Widget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__